import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom"; // Import Outlet to render child route components
import Footer from "./component/common/Footer.js";
import Header from "./component/common/Header.js";
import SideBar from "./component/common/SideBar.js";
import SessionHandler from "./component/common/SessionHandler.js";
import { useNavigate } from "react-router-dom";
import SideBarAdvanced from "./component/common/SideBarAdvanced.js";
import "./sidebar.css";
import ErrorBoundary from "./component/common/ErrorBoundary.js";
import "bootstrap/dist/js/bootstrap.bundle.min.js";


function App() {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(true);

  // Callback to update collapsed state from Sidebar
  const handleCollapseChange = (newCollapsedState) => {
    setCollapsed(newCollapsedState);
  };

  // Inline CSS for the Body Content (dynamic margin-left based on sidebar state)
  const bodyContentStyle = {
    display: "flex",
    height: "100vh",
    marginLeft: collapsed ? "60px" : "250px", // Adjust margin based on collapsed state
    transition: "margin-left 0.3s ease", // Smooth transition for resizing
  };

  return (
    <div className="App">
      {/* SessionHandler should be rendered at the top of the app */}
      <SessionHandler />

      {/* Common Layout */}
      <Header />

      {/* Body Content Layout */}
      <div className="bodyContent" style={{ height: "100vh" }}>
        {/* Sidebar */}
        {/* <SideBar onCollapseChange={handleCollapseChange} /> */}
        <SideBarAdvanced />
        {/* Main Content */}
        <div className="bodycontentstyles">
          {/* <div style={{ flex: 1, padding: '20px' }}> */}
          <ErrorBoundary>
          <Outlet />{" "}
          </ErrorBoundary>
          
          {/* This is where child components from routes will be rendered */}
          {/* </div> */}
        </div>
      </div>

      {/* Footer should always be visible */}
      <Footer />
    </div>
  );
}

export default App;
